/*
 * Slideshow 影片控制
 *  - 透明遮罩：擋掉 YouTube/Vimeo 內嵌播放器的 hover 選單與「更多影片」連結。
 *  - 喇叭鈕 + 音量滑桿：自訂聲音控制。桌機音量「跨格延續」；手機因瀏覽器限制，
 *    只有你直接操作的那格有聲，輪播到的其他格保持靜音播放（避免被手機暫停卡住）。
 *  - 保證播放：任何切換後強制播放，開聲若被瀏覽器擋下就自動退回靜音播放，絕不卡住。
 *  - 鎖：上鎖=暫停自動輪播、讓影片播完後自動繼續輪播；開鎖=正常循環＋輪播。
 * 支援：上傳影片(<video>)、YouTube、Vimeo。
 */
(function () {
  if (window.__vslLockInit) return;
  window.__vslLockInit = true;

  var idCounter = 0;

  function isMobile() {
    return !!(window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
  }

  var ytLoading = false, ytQueue = [];
  function loadYT(cb) {
    if (window.YT && window.YT.Player) return cb();
    ytQueue.push(cb);
    if (ytLoading) return;
    ytLoading = true;
    var prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof prev === 'function') prev();
      var q = ytQueue.slice(); ytQueue = [];
      q.forEach(function (f) { f(); });
    };
    var s = document.createElement('script');
    s.src = 'https://www.youtube.com/iframe_api';
    document.head.appendChild(s);
  }

  var vimeoLoading = false, vimeoQueue = [];
  function loadVimeo(cb) {
    if (window.Vimeo && window.Vimeo.Player) return cb();
    vimeoQueue.push(cb);
    if (vimeoLoading) return;
    vimeoLoading = true;
    var s = document.createElement('script');
    s.src = 'https://player.vimeo.com/api/player.js';
    s.onload = function () { var q = vimeoQueue.slice(); vimeoQueue = []; q.forEach(function (f) { f(); }); };
    document.head.appendChild(s);
  }

  function clamp(n, min, max) { return Math.max(min, Math.min(max, n)); }

  function setupSlide(slideshow, slide, audio, broadcast) {
    var lockBtn = slide.querySelector('.vsl-lock');
    var soundBtn = slide.querySelector('.vsl-sound');
    var volInput = slide.querySelector('.vsl-volume');
    var videoEl = slide.querySelector('video');
    var iframe = slide.querySelector('iframe.slideshow__video-embed');

    var lockState = { locked: false };
    var ctrl = { active: false, ready: false, slide: slide };
    var api = { replay: function () {}, _setMuted: function () {}, _setVolume: function () {}, _play: function () {} };

    // 套用聲音：桌機當前格可有聲並延續；手機只保持播放、輪播到的格一律靜音
    function applyAudio() {
      if (ctrl.active && audio.on && audio.volume > 0) {
        api._setVolume(audio.volume);
        api._setMuted(false);
      } else {
        api._setMuted(true);
      }
      api._play();
    }
    ctrl.apply = applyAudio;

    // 直接手勢：使用者在這格操作聲音時呼叫（手機也允許有聲）
    function applyDirectSound() {
      if (audio.on && audio.volume > 0) {
        api._setVolume(audio.volume);
        api._setMuted(false);
      } else {
        api._setMuted(true);
      }
      api._play();
    }

    function updateUI() {
      var on = audio.on && audio.volume > 0;
      if (soundBtn) {
        soundBtn.classList.toggle('is-on', on);
        soundBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        soundBtn.setAttribute('aria-label', on ? '關閉聲音' : '開啟聲音');
      }
      if (volInput) volInput.value = audio.on ? audio.volume : 0;
    }
    ctrl.updateUI = updateUI;

    function onEnded() {
      if (lockState.locked) {
        lockState.locked = false;
        if (lockBtn) { lockBtn.classList.remove('is-locked'); lockBtn.setAttribute('aria-pressed', 'false'); }
        try { slideshow.play(); } catch (e) {}
        try { slideshow.autoRotateSlides(); } catch (e) {}
      } else {
        api.replay();
      }
    }

    if (videoEl) {
      videoEl.removeAttribute('loop');
      videoEl.addEventListener('ended', onEnded);
      api.replay = function () { try { videoEl.currentTime = 0; safePlay(); } catch (e) {} };
      api._setMuted = function (b) { try { videoEl.muted = b; } catch (e) {} };
      api._setVolume = function (v) { try { videoEl.volume = clamp(v / 100, 0, 1); } catch (e) {} };
      function safePlay() {
        try {
          var p = videoEl.play();
          if (p && p.catch) p.catch(function () {
            try { videoEl.muted = true; var p2 = videoEl.play(); if (p2 && p2.catch) p2.catch(function () {}); } catch (e) {}
          });
        } catch (e) {}
      }
      api._play = safePlay;
      ctrl.ready = true;
    } else if (iframe && /youtube\.com|youtube-nocookie\.com/.test(iframe.src)) {
      if (!iframe.id) iframe.id = 'vsl-yt-' + (idCounter++);
      loadYT(function () {
        try {
          var yp = new YT.Player(iframe.id, {
            events: {
              onReady: function (e) { try { e.target.mute(); e.target.playVideo(); } catch (err) {} ctrl.ready = true; applyAudio(); },
              onStateChange: function (e) {
                if (e.data === YT.PlayerState.ENDED) { onEnded(); return; }
                // 防卡住：若有聲播放被手機政策擋成暫停，退回靜音續播
                if (e.data === YT.PlayerState.PAUSED && ctrl.active) {
                  try { e.target.mute(); e.target.playVideo(); } catch (err) {}
                }
              }
            }
          });
          api.replay = function () { try { yp.seekTo(0, true); yp.playVideo(); } catch (e) {} };
          api._setMuted = function (b) { try { if (b) { yp.mute(); } else { yp.unMute(); } } catch (e) {} };
          api._setVolume = function (v) { try { yp.setVolume(clamp(v, 0, 100)); } catch (e) {} };
          api._play = function () { try { yp.playVideo(); } catch (e) {} };
        } catch (err) {}
      });
    } else if (iframe && /vimeo\.com/.test(iframe.src)) {
      loadVimeo(function () {
        try {
          var vp = new Vimeo.Player(iframe);
          try { vp.setMuted(true); vp.setLoop(false); } catch (e) {}
          vp.on('ended', onEnded);
          vp.ready().then(function () { ctrl.ready = true; applyAudio(); }).catch(function () {});
          api.replay = function () { try { vp.setCurrentTime(0); vp.play(); } catch (e) {} };
          api._setMuted = function (b) { try { vp.setMuted(b); } catch (e) {} };
          api._setVolume = function (v) { try { vp.setVolume(clamp(v / 100, 0, 1)); } catch (e) {} };
          api._play = function () {
            try { var p = vp.play(); if (p && p.catch) p.catch(function () { try { vp.setMuted(true); vp.play(); } catch (e) {} }); } catch (e) {}
          };
        } catch (err) {}
      });
    } else {
      return null;
    }

    if (lockBtn) {
      lockBtn.addEventListener('click', function () {
        lockState.locked = !lockState.locked;
        lockBtn.classList.toggle('is-locked', lockState.locked);
        lockBtn.setAttribute('aria-pressed', lockState.locked ? 'true' : 'false');
        if (lockState.locked) { try { slideshow.pause(); } catch (e) {} }
        else { try { slideshow.play(); } catch (e) {} }
      });
    }

    if (soundBtn) {
      soundBtn.addEventListener('click', function () {
        if (!audio.on || audio.volume === 0) { audio.on = true; if (audio.volume === 0) audio.volume = 70; }
        else { audio.on = false; }
        broadcast();
        applyDirectSound(); // 直接手勢：這格立即套用（手機亦可有聲）
      });
    }
    if (volInput) {
      volInput.addEventListener('input', function () {
        audio.volume = parseInt(volInput.value, 10) || 0;
        audio.on = audio.volume > 0;
        broadcast();
        applyDirectSound();
      });
    }

    updateUI();
    return ctrl;
  }

  function initSlideshow(slideshow) {
    if (slideshow.__vslDone) return;
    slideshow.__vslDone = true;

    var audio = { on: false, volume: 0 };
    var controllers = [];

    function broadcast() {
      controllers.forEach(function (c) { c.apply(); c.updateUI(); });
    }

    slideshow.querySelectorAll('.slideshow__slide').forEach(function (slide) {
      if (slide.querySelector('.vsl-controls')) {
        var c = setupSlide(slideshow, slide, audio, broadcast);
        if (c) { slide.__vslCtrl = c; controllers.push(c); }
      }
    });
    if (!controllers.length) return;

    var root = slideshow.querySelector('.slider') || slideshow;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var c = entry.target.__vslCtrl;
          if (!c) return;
          c.active = entry.intersectionRatio >= 0.5;
          c.apply();
        });
      }, { root: root, threshold: [0, 0.5, 1] });
      controllers.forEach(function (c) { io.observe(c.slide); });
    }
  }

  function init() {
    document.querySelectorAll('slideshow-component').forEach(initSlideshow);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
